import { Component, Input, OnInit } from '@angular/core';
import { FormType } from '../../form-designer/form-type.enum';
import { ReferenceLibraryService } from 'reference-library';
import { take } from 'rxjs/operators';
import { ReferenceLibrary } from 'app-models';
import { FdDetailNavSectionService } from '../../form-designer/fd-detail-nav-section/fd-detail-nav-section.service';
import { AppServicesLibraryService } from 'app-services-library';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/data/models/app-state';
import * as FB from 'src/app/modules/form-designer/fb-state/actions/fb.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { MarkCleanFormAction, selectFormDirty } from 'dirty-check-store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { CustomButtonActionService } from 'custom-button-action';
@Component({
  selector: 'app-fb-horizontal-tab',
  templateUrl: './fb-horizontal-tab.component.html',
  styleUrls: ['./fb-horizontal-tab.component.scss']
})
export class FbHorizontalTabComponent implements OnInit {
  @Input() formBuilderInfo: any;
  // @Input() horiSteps: any[] = [];
  activeIndex: any;
  fbTabFormType: any;
  pageFormType: any;
  simpleFormButton: any;
  fbPageTypeArr: ReferenceLibrary[];
  formTypeSelected: string;
  isFBModulePreview = false;
  tabFormBuilderInfo: any;
  formBuilderTabInfo: any;
  formDataId: any;
  showSimpleForm: boolean;
  showPageTitleSection: boolean;
  selectedIndex: number;
  isMultiStepForm: boolean = null;
  steps: any[] = [];
  buttonClicked: boolean = false;
  onBackToMasterListReference: any;
  interviewRounds: any;
  isMultiDataSrc: boolean;
  interviewProcessId: any;
  previousIndex: any;
  isHandleClicked: boolean = false;
  prevRedirectPageFormId: number;
  backPageFormId: any;
  isBackPageFormIdExtracted: boolean = false;
  fbFormMlDataDTO: any;
  dashboardNotificationType: string;

  constructor(
    private referenceLibraryService: ReferenceLibraryService,
    private fdDetailNavSectionService: FdDetailNavSectionService,
    private appServicesLibraryService: AppServicesLibraryService,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
    private customButtonActionService: CustomButtonActionService,
    private ngxService: NgxUiLoaderService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.activeIndex = (sessionStorage.getItem('redirectTabIndex') && parseInt(sessionStorage.getItem('redirectTabIndex')) !== 0
  ? parseInt(sessionStorage.getItem('redirectTabIndex'))
  : this.fdDetailNavSectionService.getActiveTabIndex()) || 0;

   // this.activeIndex = ('redirectTabIndex' in sessionStorage ? parseInt(sessionStorage.getItem('redirectTabIndex')) : this.fdDetailNavSectionService.getActiveTabIndex()) || 0;
    this.onLoadTabFormInfo(this.activeIndex)
    const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
    this.fbFormMlDataDTO = this.getLatestRowID();
    if (sessionStorage.getItem('dashboardNotificationType')) {
      this.dashboardNotificationType = sessionStorage.getItem('dashboardNotificationType');
    }
  }
  getLatestRowID() {
    const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
    return fbFormDataDTO[fbFormDataDTO.length - 1];
  }
  getTabPageFormInfo(tabPageFormId) {
    this.prevRedirectPageFormId = 'prevRedirectPageFormId' in sessionStorage ? parseInt(sessionStorage.getItem('prevRedirectPageFormId')) : null;
    this.fdDetailNavSectionService.getPageFormById(tabPageFormId)
      .pipe(take(1)).subscribe((formBuilderTabInfo: any) => {
        if (formBuilderTabInfo) {
          this.formBuilderTabInfo = formBuilderTabInfo;

          //Extract onBackAction config for back button redirection
          if (!this.isBackPageFormIdExtracted &&
            this.formBuilderTabInfo?.formBuilderPageFormButtons?.[0]?.pageFormJson &&
            !this.dashboardNotificationType) {
            const backPageFormId = JSON.parse(this.formBuilderTabInfo.formBuilderPageFormButtons[0].pageFormJson);
            const targetObject = backPageFormId.find((x: any) => x.isOmit);
            this.backPageFormId = targetObject?.onBackAction;
            this.isBackPageFormIdExtracted = true;
          }

          sessionStorage.setItem('moduleId', this.formBuilderTabInfo.moduleId);
          sessionStorage.setItem('pageFormId', this.formBuilderTabInfo.id);
          this.simpleFormButton = this.formBuilderTabInfo.formBuilderPageFormButtons?.[0] ?? null;
          this.getSimpleFormDetails();
          if (this.pageFormType === 'master_listing_table') {
            this.showPageTitleSection = true;
            this.showSimpleForm = false;
            this.isMultiStepForm = false;
          } else {
            this.showSimpleForm = true;
            this.showPageTitleSection = this.pageFormType === 'form_builder_dashboard';
          }
          if (this.simpleFormButton && this.fbPageTypeArr) {
            this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId)?.code;
          }


        }
        // this.showPageInfo = true;
      });
  }

  getSimpleFormDetails() {
    this.referenceLibraryService.getReferenceData('FB_PAGE_TYPE')
      .pipe(take(1))
      .subscribe((response: any) => {
        this.fbPageTypeArr = response;
        if (this.simpleFormButton && this.fbPageTypeArr) {
          // this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.formBuilderInfo.fbPageFormTabs[0].buildFormatTypeId).code;
          this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId)?.code;
          if (this.formTypeSelected === 'MultiStep') {
            if (this.simpleFormButton.isMultiDataSrc) {
              this.getInterviewRounds();
            } else {
              this.onMultiStep();
            }
          }
        }
      });
  }

  onMultiStep() {
    this.steps = this.getSteps();
    if (this.pageFormType !== 'master_listing_table') {
      this.showSimpleForm = false;
      this.isMultiStepForm = true;
    }
    this.onBackToMasterListReference = this.onBackToMasterList.bind(this);
  }
  handleTabChange(e) {
    this.dirtyCheckForFormsBuilder(e)
    this.activeIndex = e.index;
    this.fdDetailNavSectionService.setActiveTabIndex(this.activeIndex);
  }
  handleTabAction(e) {
    this.dirtyCheckForFormsBuilder(e)
  }
  performTabChange(e) {
    if (typeof e === 'object' && 'index' in e && 'originalEvent' in e) {
      this.selectedIndex = e.index;
    } else {
      this.selectedIndex++;
      this.activeIndex = this.selectedIndex;
    }
    this.showPageTitleSection = false;
    this.formBuilderTabInfo = null;
    this.showSimpleForm = false;
    this.isMultiStepForm = false;
    this.formTypeSelected = null;
    this.simpleFormButton = null;
    this.formDataId = null;
    sessionStorage.removeItem("pageFormId");
    this.onLoadTabFormInfo(this.activeIndex);

  }

  getInterviewRounds() {
    this.interviewProcessId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
    if (this.interviewProcessId) {
      this.fdDetailNavSectionService.getInterviewRoundsById(this.interviewProcessId)
        .pipe(take(1))
        .subscribe((data: any[]) => {
          this.interviewRounds = data || [];
          this.onMultiStep();
        });
    }
  }

  getSteps(): any[] {
    if (this.simpleFormButton && this.simpleFormButton.pageFormJson) {
      const pageFormJson = JSON.parse(this.simpleFormButton.pageFormJson);
      if (Array.isArray(pageFormJson)) {
        let filteredFields = pageFormJson.filter(field => !('emptyCol' in field && field.emptyCol) && !(field.isOmit === true));
        if (this.simpleFormButton.isMultiDataSrc) {
          let uniqueRowNumbers = [];
          let tempFilterFields = [];
          filteredFields.forEach(field => {
            uniqueRowNumbers.push({ rowNumber: field.numberOfRow });
          });
          this.interviewRounds.forEach((round, index) => {
            tempFilterFields.push(...filteredFields.map((field, i) => {
              let groupName = field.groupName;
              let numberOfRow = field.numberOfRow;
              let uniqueName = field.name;

              const parts = groupName.split('_');
              const lastPart = parts.pop();
              const restOfString = parts.join('_');
              groupName = uniqueName + '_' + round.id + '_' + restOfString + '_' + this.appServicesLibraryService.uuid();
              const existingField = uniqueRowNumbers.find(item => item.rowNumber === numberOfRow);
              if (existingField) {
                numberOfRow = existingField.rowNumber;
              }

              return {
                ...field,
                stepNumber: index + 1,
                stepName: round.interviewType,
                groupName,
                stepId: round.id,
                name: groupName,
                numberOfRow,
              };
            }));

          });
          filteredFields = [...tempFilterFields];
        }
        // else {
        const uniqueStepNumbers = [...new Set(filteredFields.map(field => field.stepNumber || 1))];
        return uniqueStepNumbers.map(stepNumber => {
          const stepFields = filteredFields.filter(field => (field.stepNumber || 1) === stepNumber);
          const stepLabel = stepFields.length > 0 ? stepFields[0].stepName || `Step ${stepNumber}` : `Step ${stepNumber}`;
          return {
            label: stepLabel,
            simpleFormButton: this.simpleFormButton,
            pageFormType: this.pageFormType,
            formTypeSelected: this.formTypeSelected,
            isFBModulePreview: this.isFBModulePreview,
            formBuilderInfo: this.formBuilderInfo,
            formDataId: this.formDataId,
            stepNumber: stepNumber || 1,
            fields: stepFields,
          };
        }).filter((step, index, self) => {
          return index === self.findIndex(s => s.stepNumber === step.stepNumber);
        });
        // }
      }
    }

    return [
      {
        label: 'Step 1',
        simpleFormButton: this.simpleFormButton,
        pageFormType: this.pageFormType,
        formTypeSelected: this.formTypeSelected,
        isFBModulePreview: this.isFBModulePreview,
        formBuilderInfo: this.formBuilderInfo,
        formDataId: this.formDataId,
        stepNumber: 1,
        fields: [],
      },
    ];
  }
  onBackToMasterList() {
    this.showSimpleForm = false;
    this.simpleFormButton = null;
    this.isMultiStepForm = false;
    const tabPageFormId = this.formBuilderInfo.fbPageFormTabs[this.activeIndex].pageFormId;
    this.getTabPageFormInfo(tabPageFormId);
    // this.isShowPageTitleSection(true);
  }
  onLoadTabFormInfo(index) {
    this.previousIndex = index;
    this.pageFormType = FormType[this.formBuilderInfo?.fbPageFormTabs[index]?.buildFormatTypeId];
    const tabPageFormId = this.formBuilderInfo.fbPageFormTabs[index].pageFormId;
    this.getTabPageFormInfo(tabPageFormId);
  }
  removeLastItemFbFormDataDTO() {
    if ('formName' in sessionStorage) {
      let formName = sessionStorage.getItem('formName');
      if ('fbFormDataDTO' in sessionStorage) {
        let fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
        if (fbFormDataDTO.length > 1) {
          fbFormDataDTO = fbFormDataDTO.slice(0, -1);
        }
        if (fbFormDataDTO.length === 0) {
          sessionStorage.removeItem('fbFormDataDTO');
        } else {
          sessionStorage.setItem('fbFormDataDTO', JSON.stringify(fbFormDataDTO));
        }
      }
    } else {
      if ('fbFormDataDTO' in sessionStorage) {
        let fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
        if (fbFormDataDTO.length > 1) {
          fbFormDataDTO = fbFormDataDTO.slice(0, -1);
        }
        if (fbFormDataDTO.length === 0) {
          sessionStorage.removeItem('fbFormDataDTO');
        } else {
          sessionStorage.setItem('fbFormDataDTO', JSON.stringify(fbFormDataDTO));
        }
      }
    }
  }
  goBack(pageFormId: number) {
    this.customButtonActionService.getPageFormById(pageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          if ('fbFormDataDTO' in sessionStorage) {
            this.removeLastItemFbFormDataDTO();
            if ('fbFormDataDTO' in sessionStorage) {
              const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
              sessionStorage.setItem('idToGetDetails', fbFormDataDTO[fbFormDataDTO.length - 1].id);
            }
            else {
              sessionStorage.removeItem('idToGetDetails');
            }
          }
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          }
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }
  handleAction(e) {
    if (!e.isBeneficiaryProfileListing) {
      sessionStorage.setItem('formDataId', e.id);
      this.formDataId = e.id;
      if (this.fbPageTypeArr) {
        this.simpleFormButton = this.formBuilderInfo.formBuilderPageFormButtons[0];
        this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId).code;
      }
    } else {
      sessionStorage.setItem('FbEmployeeId', e.beneficiaryId);
    }
    if (e.isBeneficiaryProfileListing && e.redirectTo === 0) {
      this.store.dispatch(new FB.SetIsBeneficiaryProfile(true));
      setTimeout(() => {
        this.router.navigate([`../employee/profile/education`], {
          queryParams: {
            pageFrom: 'FB',
            fbEmpId: e.id
          },
          relativeTo: this.route
        });
      }, 0);
    } else {
      sessionStorage.setItem('formDataId', e.id);
      this.formDataId = e.id;
      if (this.formTypeSelected === 'MultiStep') {
        this.steps = this.getSteps();
        this.showSimpleForm = false;
        this.isMultiStepForm = true;
        this.onBackToMasterListReference = this.onBackToMasterList.bind(this);
        //this.buttonClicked = true;
      } else {
        this.isMultiStepForm = false;
        this.showSimpleForm = true;
      }
    }
    this.isHandleClicked = true;
  }

  dirtyCheckForFormsBuilder(item) {
    this.store.select(selectFormDirty).pipe(
      take(1)).subscribe(formState => {
        if (!formState.dirty) {
          this.performTabChange(item);
        } else {
          this.ngxService.stopAll();
          return this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'If you leave before saving, all changes made on the page will be lost. Do you wish to continue?'
              },
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).beforeClosed().pipe(take(1)).subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({
                dirty: false
              }));
              this.performTabChange(item);
            } else {
              setTimeout(() => {
                this.activeIndex = this.previousIndex;
              });
            }
          });

        }
      });
  }

  onPageFormButtonClicked(item: any) {
    this.simpleFormButton = item;
    this.buttonClicked = true;
    if (this.formTypeSelected === 'MultiStep') {
      this.isMultiStepForm = true;
      this.showSimpleForm = false;
    } else {
      this.showSimpleForm = true;
      this.isMultiStepForm = false;
    }
    this.formDataId = null;
    //  this.isShowPageTitleSection();
  }

  ngOnDestroy(): void {
    const isRedirectClicked = this.fdDetailNavSectionService.getisRedirectClicked();
    if (!this.buttonClicked && !this.isHandleClicked && isRedirectClicked === false) {
      this.fdDetailNavSectionService.setActiveTabIndex(0);
    }
  }
}
